// Runtime config, read from <meta> tags in index.html. The self-hosted server
// substitutes the %TOKEN% placeholders at request time (see server.js), so the
// same built bundle can point at any environment without a rebuild — mirroring
// the marketing site's CONSOLE_URL injection. In dev (or if the server didn't
// template the HTML) the token is left unreplaced, so we fall back to a default.

function readMeta(name: string, fallback: string): string {
  const content = document.querySelector(`meta[name="${name}"]`)?.getAttribute('content')?.trim()
  if (!content || content.startsWith('%')) return fallback
  return content
}

// Where the marketing site lives — target of the footer's "TryVouchr" link and
// the Privacy / Terms links. Defaults to the tailnet web host (matching the
// CONSOLE_URL default on the marketing side); set MARKETING_URL to override,
// e.g. https://tryvouchr.com in production.
export const MARKETING_URL = readMeta('marketing-url', 'https://tryvouchr-web.beaver-noodlefish.ts.net')

// Where the PocketBase backend lives — the browser talks to it directly for
// auth and all console data. The self-hosted server injects the production URL
// via the %POCKETBASE_URL% token; in local dev it falls back to a PocketBase
// running on the standard 8090 port (`pocketbase serve`).
export const POCKETBASE_URL = readMeta('pocketbase-url', 'http://127.0.0.1:8090')

// Stripe publishable key, used to mount Elements (card entry) on the Billing
// screen. Safe to expose — the secret key lives only in the api service. The
// self-hosted server injects it via the %STRIPE_PUBLISHABLE_KEY% token; left
// empty in dev unless set, in which case the billing UI shows a config notice.
export const STRIPE_PUBLISHABLE_KEY = readMeta('stripe-publishable-key', '')
